module.exports = __webpack_public_path__ + "img/facebook.763872e1.svg";